// API endpoint'leri
export const API_ENDPOINTS = {
  // Chat endpoint'leri
  ask: "/api/v1/ai/chat",
  creativeGeneration: "/api/v1/ai/chat/creative-generation",
  creativeGenerationEstimateCost:
    "/api/v1/ai/chat/creative-generation/estimate-cost",

  // Auth endpoint'leri
  login: "/auth/login",
  changePassword: "/auth/change-password",
  logout: "/auth/logout",
  googleAuth: "/auth/google",
  appleToken: "/auth/apple/token",
  facebookAuth: "/auth/facebook",
  register: "/users/register",
  resendVerificationCode: "/users/resend-verification",
  forgotPassword: "/auth/forget-password",
  resetPassword: "/auth/reset-password",
  refreshToken: "/auth/refresh-token",

  // User endpoint'leri
  verifyUser: "/users/verify",
  getMe: "/users/me",
  uploadImage: "/users/upload-image",
  updateLanguage: "/users/language",
  updateTheme: "/users/theme",
  deleteAccount: (userId: string) => `/users/delete/${userId}`,
  updateUser: "/users/update-user-info",
  userMeta: "/users/meta",
  updateProfile: "/users/update-profile",
  loginHistory: "/users/login-history",
  checkUserExists: "/users/check-exists",

  // Conversation endpoint'leri
  getConversations: "/conversations",
  addMessage: "/conversations/add-message",
  createConversation: "/conversations/create-conversation",
  deleteConversation: (conversationId: string) =>
    `/conversations/delete-conversation/${conversationId}`,
  getMessagesFromConversation: (conversationId: string) =>
    `/conversations/${conversationId}`,
  getMessagesInfiniteScroll: (conversationId: string) =>
    `/conversations/infinite-scroll/${conversationId}`,
  changeConversationName: (conversationId: string) =>
    `/conversations/change-name/${conversationId}`,
  getMessageInput: (messageId: string) =>
    `/conversations/inputs/get-by-message/${messageId}`,
  getUserPromptByMessageId: (messageId: string) =>
    `/conversations/inputs/get-user-prompt-by-message-id/${messageId}`,
  getAllPublicMessages: "/conversations/inputs/get-all-public-messages",
  getShareLink: "/conversations/get-share-link",
  removeShareToken: (conversationId: string) =>
    `/conversations/remove-share-token/${conversationId}`,
  updateMessageFeedback: "/conversations/feedback",

  // Credits endpoint'leri
  getCredits: "/credits",
  purchaseCredits: "/credits/purchase",

  // LLM Model endpoint'leri
  getAllLLMModels: "/llm-model/get-all-llm-model",
  getSingleLLMModel: (id: string) => `/llm-model/get-single-llm-model/${id}`,
  getLLMCategorySubcategories: (id: string) =>
    `/llm-category/${id}/subcategory`,

  // LLM Model Favorites endpoint'leri
  getLLMModelFavorites: "/llm-model/favorites",
  addToFavorites: "/llm-model/favorites",

  // LLM Model Comments endpoint'leri
  getLLMModelComments: (modelId: string) => `/llm-model/comments/${modelId}`,
  addLLMModelComment: "/llm-model/comments/",

  // LLM Model Rating endpoint'leri
  getLLMModelRating: (modelId: string) => `/llm-model/rating/${modelId}`,
  addLLMModelRating: "/llm-model/rating",

  // Eachalab Model endpoint'leri
  getAllEachalabModels: "/eachalab-model/get-all-eachalab-model",

  // Pricing endpoint'leri
  getAllPricing: "/pricing/get-all-pricing",

  // Subscription endpoint'leri
  createCheckoutSession: "/subscription/post-checkout-session",
  checkoutSessionStatus: (sessionId: string) =>
    `/subscription/get-checkout-session-status/${sessionId}`,
  getBillingHistory: "/subscription/billing-history?include=billing",
  cancelSubscription: "/subscription/post-cancel-subscription",
  customerPortal: "/subscription/customer-portal",
  comparePricingPlan: "/subscription/compare-pricing-plan",
  activeCoupon: (area: string) =>
    `/subscription/active-coupon?area=${encodeURIComponent(area)}`,

  // Address endpoint'leri
  getAddresses: "/shop/get-address",
  addAddress: "/shop/post-address",
  updateAddress: (id: string) => `/shop/update-address/${id}`,
  deleteAddress: (id: string) => `/users/delete-address/${id}`,

  // 🎯 Widget System API Endpoint'leri
  enhancePrompt: "/enhance-prompt/enhance-prompt/",
  generateImage: "/image-generator/text-image-generate",

  // 🎯 Prompt Enhancement API Endpoint'leri
  promptEnhance: "/api/v1/ai/chat/prompt/enhance",
  promptTranslate: "/api/v1/ai/chat/prompt/translate",

  // 🎙️ Dictation (Speech-to-Text) — chat UI için hafif endpoint
  transcribeAudio: "/api/v1/transcribe/text",

  // 🛒 Shop/Cart endpoint'leri
  addToCart: "/shop/add-to-cart",
  updateCartQuantity: (cartId: string) => `/shop/update-cart/${cartId}`,
  getAllCart: "/shop/get-all-cart", // Updated: Now returns hierarchical structure
  deleteFromCart: (cartId: string) => `/shop/delete-cart/${cartId}`,
  cartSelection: "/shop/cart-selection",

  // 🧾 Checkout endpoint'leri
  checkoutCardInfo: "/shop/checkout/card-info",
  checkoutAgreements: "/shop/checkout/agreements",
  checkout: "/shop/checkout",
  checkoutStatus: (orderGroupId: string) =>
    `/shop/checkout/status/${orderGroupId}`,
  checkoutApprovals: "/shop/checkout-approvals",

  // 💳 Saklı Kart endpoint'leri
  getCards: "/cards",
  deleteCard: (cardToken: string) => `/cards/${cardToken}`,

  // 🧾 Orders endpoint'leri
  getOrders: "/shop/order-groups",
  getOrderGroup: (orderGroupId: string) => `/shop/orders/group/${orderGroupId}`,

  // 🛍️ E-commerce Brand endpoint'leri
  getBrandByBrandId: (id: string | number) => `/shop/brands/by-brand-id/${id}`,

  // 🛍️ E-commerce Product endpoint'leri
  getProductDetail: (productId: string) => `/shop/products/${productId}`,

  // ❤️ Favori ürün endpoint'leri (GET liste, POST ekle/çıkar — aynı path)
  favoriteProducts: "/shop/products/favorites",

  // 🛍️ E-commerce Category endpoint'leri
  getMainCategories: "/category/main-categories",
  getSubCategoriesByMainCategory: (mainCategoryName: string) =>
    `/category/by-main-category/${mainCategoryName}`,

  // 🛍️ E-commerce Seller endpoint'leri
  getPopularSellers: "/seller/popular",

  // 🛍️ E-commerce Featured Products endpoint'leri
  getFeaturedProducts: "/shop/products/featured",

  // 🎯 Site Config endpoint'leri
  getSiteConfigs: "/site-configs",

  // 🎬 Render (Remotion Lambda) endpoint'leri
  render: "/render",
  renderProgress: (renderId: string) => `/render/${renderId}`,
  renderCancel: (renderId: string) => `/render/${renderId}`,

  // 📚 Library endpoint'leri
  getLibrary: "/library",
  bulkDeleteLibrary: "/library/bulk-delete",
  changeLibraryItemVisibility: (libraryItemId: string) =>
    `/library/change-library-item-visibility/${libraryItemId}`,
  libraryZip: (messageId: string) => `/library/zip/${messageId}`,
  libraryZipSelection: "/library/zip",
  libraryZipStatus: (workflowId: string) => `/library/zip/status/${workflowId}`,
  libraryItem: (libraryItemId: string) => `/library/${libraryItemId}`,
  libraryItemFavorite: (libraryItemId: string) =>
    `/library/${libraryItemId}/favorite`,
  libraryBulkFavorite: "/library/bulk-favorite",
  libraryBulkFolder: "/library/bulk-folder",
  libraryStats: "/library/stats",
  libraryFolders: "/library/folders",
  libraryFolder: (folderId: string) => `/library/folders/${folderId}`,

  // 📊 Token Usage endpoint'leri
  getUserUsageAnalytics: "/token-usage/user-usage-analytics",
  getUserTokenUsageHistoryByModel:
    "/token-usage/user-token-usage-history-by-model",
  getUserTokenUsageHistory: "/token-usage/user-token-usage-history",
  uploadFile: "/library/upload",
  uploadFromUrl: "/library/upload-from-url",

  // 📝 Agreement endpoint'leri
  getAgreement: (name: string) => `/agreements/${name}`,
  confirmAgreement: "/agreements/confirm",

  // 📍 Location endpoint'leri
  getLocation: "/location",

  // 🎬 Editor Projects endpoint'leri
  getEditorProjects: "/editor-projects",
  getEditorProjectById: (id: string) => `/editor-projects/${id}`,
  createEditorProject: "/editor-projects",
  updateEditorProject: (id: string) => `/editor-projects/${id}`,
  deleteEditorProject: (id: string) => `/editor-projects/${id}`,

  // 🎨 Preferences endpoint'leri
  CATEGORY_PREFERENCES: "/category/preferences",
  USER_PREFERENCES: "/users/get-preferences",
  UPDATE_PREFERENCES: "/users/update-preferences",

  // 🎁 Rewards endpoint'leri
  getRewards: "/users/rewards",
  getRewardsHistory: "/users/rewards/history",
  convertRewards: "/users/rewards/convert",
  previewConvertRewards: "/users/rewards/convert/preview",

  // 🛫 Cosmopoints (partner loyalty programs) endpoint'leri
  getCosmopointsPrograms: "/cosmopoints/programs",
  getCosmopointsConnections: "/cosmopoints/connections",
  createCosmopointsConnection: "/cosmopoints/connections",
  deleteCosmopointsConnection: (id: string) => `/cosmopoints/connections/${id}`,

  // 👗 Try-On Fotoğrafları endpoint'leri
  getTryOnPhotos: "/wardrobe/try-on-photos",
  addTryOnPhoto: "/wardrobe/try-on-photos",
  updateTryOnPhoto: (photoId: string) => `/wardrobe/try-on-photos/${photoId}`,
  deleteTryOnPhoto: (photoId: string) => `/wardrobe/try-on-photos/${photoId}`,

  // 📮 Contact / Support endpoint'leri
  sendContact: "/contact/send-contact",
  getAllContact: "/contact/get-all-contact",
  getSingleContact: (id: string) => `/contact/get-single-contact/${id}`,
  addContactMessage: (id: string) => `/contact/add-contact-message/${id}`,
  updateContactStatus: (id: string) =>
    `/contact/update-contact-status/${id}`,
  getContactStats: "/contact/stats",
} as const;

// Address endpoints
export const ADDRESS_ENDPOINTS = {
  GET_ADDRESSES: "/users/addresses",
  ADD_ADDRESS: "/users/addresses",
  UPDATE_ADDRESS: "/users/addresses",
  DELETE_ADDRESS: "/users/delete-address",
} as const;

export const ONBOARDING_ENDPOINTS = {
  levels: "/onboarding/levels", // Baştaki /api/v1 kısmını baseURL zaten ekliyor olabilir, kontrol edeceğiz
  progress: "/onboarding",
  skip: "/onboarding/skip",
  selfieUpload: "/onboarding/selfie/upload",
  generate: "/onboarding/generate",
  status: (generationId: string) =>
    `/onboarding/generate/${generationId}/status`,
} as const;
